interface StepperProps {
  steps: Array<{ label: string; done: boolean; current: boolean }>;
}

export function Stepper({ steps }: StepperProps) {
  return (
    <ol className="mb-6 flex items-center gap-2">
      {steps.map((s, i) => (
        <li key={s.label} className="flex flex-1 items-center gap-2">
          <span
            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-medium ${
              s.done
                ? 'bg-green-600 text-white'
                : s.current
                  ? 'bg-blue-600 text-white'
                  : 'bg-slate-200 text-slate-500'
            }`}
          >
            {s.done ? '✓' : i + 1}
          </span>
          <span
            className={`text-sm ${s.current ? 'font-semibold text-slate-900' : 'text-slate-500'}`}
          >
            {s.label}
          </span>
          {i < steps.length - 1 && <span className="ml-2 h-px flex-1 bg-slate-200" />}
        </li>
      ))}
    </ol>
  );
}
